module.exports = __webpack_public_path__ + "img/benefit-1-active.bf5df324.svg";